import { render, staticRenderFns } from "./HeaderTopSocials.vue?vue&type=template&id=5c611d85&"
import script from "./HeaderTopSocials.vue?vue&type=script&lang=js&"
export * from "./HeaderTopSocials.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTopSocials.vue?vue&type=style&index=0&id=5c611d85&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports